import { useQuery } from '@tanstack/react-query';
import type { Product } from '../data/product';
import { productCostHistoryQueryOptions } from '../query/query-options';
import { storeLayout } from '../router';

// Call this only from a component that is mounted when the cost history is
// actually wanted — mounting it speculatively (e.g. in every table row)
// registers a query per row, and each of those cache events costs a full
// IndexedDB rewrite of the persisted cache.
export function useProductCostHistory(product: Product) {
  const { store, productService } = storeLayout.useRouteContext();

  const { data, isLoading } = useQuery({
    ...productCostHistoryQueryOptions(store.id, product.vendor_id, product.id),
    queryFn: () => productService.getProductCostHistory(store.id, product.vendor_id, product.id),
  });

  return { costHistory: data, loading: isLoading };
}
